import type { FC } from 'react';
import { AdsHistory } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { Guard, usePermissionGuard } from 'features/login';
import type { MarketingProcess } from 'types/shared';

interface AdsHistoryPageProps {
  marketingProcess?: MarketingProcess;
  embedded?: boolean;
}

const AdsHistoryPage: FC<AdsHistoryPageProps> = ({
  marketingProcess,
  embedded = false,
}) => {
  const { accessToViewAdlog } = usePermissionGuard();

  const content = <AdsHistory marketingProcess={marketingProcess} />;

  if (embedded) {
    return content;
  }

  return (
    <Guard hasAccess={accessToViewAdlog} fallback>
      <CabinetTitlePage title={'Ads History'} />
      {content}
    </Guard>
  );
};

export default AdsHistoryPage;
